/**
 * Settings Parameters Constants
 * Central definition of all settings parameter groups
 * Used by both robotSettings.js and utils.js
 */

export const SETTINGS_PARAMS = {
  END_USER: [
    'UX_SHOW_COUNTDOWN_BEFORE_SHOOTING',
    'UX_DELAY_WHILE_SHOWING_PICTURE',
    'UX_SOUND_ALLOW',
    'UX_COUNTDOWN_DELAY_MS',
    'UX_USE_QR_CODE_BASED_IMAGE_ACCESS',
    'UX_DISPLAY_RECENT_PHOTOS_STRIP',
    'UX_EXPIRE_PHOTO_ICON_STRIP_MINUTES',
  ],
  PHOTO_DIST: ['SHARING_OCCO_ALBUM_NAME', 'SHARING_UPLOAD_TO_OCCO_CLOUD', 'MEDIA_DO_RUN_SCRIPT_ON_IMAGE_CAPTURE'],
  CAMERA: [
    'CAMERA_SHUTTER_SPEED',
    'CAMERA_ISO_AUTO_DETECT',
    'CAMERA_EXPOSURE_COMP',
    'CAMERA_ISO_MAX_AT_DISTANCE',
    'CAMERA_ISO_INDEX_MIN',
    'CAMERA_ISO_INDEX_MAX',
  ],
  ADMIN: ['ADMIN_MAIN_EMAIL', 'ADMIN_CC_EMAIL', 'ADMIN_LOW_DISK_SPACE_WARNING_GB'],
  PERSON_TRACK: [
    'FACE_MAY_USE',
    'FACE_REQUIRED_TO_SHOOT',
    'FACE_PID_MULTIPLIER',
    'FACE_ACCEL_SCALER',
    'DEPTH_MAX_SKELETON_DISTANCE',
    'FACE_MINIMUM_SIZE',
    'UX_DO_NOT_SHOOT_WITHOUT_GESTURE',
  ],
  WATERMARK: [
    'WATERMARK_FILE_LIVE_VIEW_S3_PATH',
    'WATERMARK_FILE_SENT_PHOTOS_S3_PATH',
    'WATERMARK_FILE_LIVE_VIEW',
    'WATERMARK_FILE_LIVE_VIEW_UPDATED',
    'WATERMARK_FILE_SENT_PHOTOS',
    'WATERMARK_FILE_SENT_PHOTOS_UPDATED',
  ],
};
